import { render, staticRenderFns } from "./watiApply.vue?vue&type=template&id=c081bf10&scoped=true"
import script from "./watiApply.vue?vue&type=script&lang=js"
export * from "./watiApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c081bf10",
  null
  
)

export default component.exports